export default __webpack_public_path__ + "static/media/press2.1b1b8af3.jpg";